export default {
  女装: "Abbigliamento Donna",
  男装: "Uomo",
  手机和小工具: "Cellulari e gadget",
  居家生活: "vita domestica",
  电脑及周边设备: "Computer e apparecchiature periferiche",
  美容及个人护理: "Bellezza e cura personale",
  家用电器: "elettrodomestici",
  健康与保健: "salute e benessere",
  食品和饮料: "cibo e bevande",
  玩具_儿童和婴儿: "giocattoli, bambini e neonati",
  童装时尚: "moda per bambini",
  视频游戏: "videogiochi",
  运动与户外: "Sport e attività all'aria aperta",
  爱好与书籍: "Hobby e libri",
  相机和无人机: "Telecamere e droni",
  宠物食品及用品: "Alimenti e forniture per animali domestici",
  女士包袋: "borse da donna",
  男士包袋: "borse da uomo",
  珠宝及配饰: "Gioielli e accessori",
  手表: "orologio",
  女鞋: "scarpe da donna",
  男装鞋: "scarpe da uomo",
  汽车: "auto",
  我附近的ShopeePay: "ShopeePay vicino a me",
  餐饮_旅行和服务: "Ristorazione, viaggi e servizi",
  旅行及行李: "Viaggi e bagagli",
  各种各样的: "Diversi tipi",
  我是来买什么的: "Cosa sono qui per comprare?",
  对不起_找不到_相关的商品:
    "Spiacenti, nessun prodotto correlato a [{0}] trovato",
  类别: "categoria",
  产品: "Prodotto",
  店铺: "negozio",
  首页: "prima pagina",
  限时秒杀: "Vendita flash per un periodo limitato",
  博客: "blog",
  所有品牌: "Tutti i marchi",
  所有类别: "Tutte le categorie",
  我的购物车: "il mio carrello della spesa",
  发货信息: "Informazioni di consegna",
  交货信息: "Informazioni di consegna",
  付款: "Pagamento",
  确认: "Confermare",
  您的购物车是空的: "Il tuo carrello è vuoto",
  价格: "prezzo",
  税: "Imposta",
  数量: "quantità",
  总计: "totale",
  移除: "Rimuovere",
  返回商店: "Ritorna al negozio",
  继续发货: "Continua a spedire",
  筛选: "filtro",
  价格范围: "fascia di prezzo",
  排序方式: "ordina per",
  最新: "aggiornato",
  最旧: "più antico",
  价格从低到高: "Prezzo da basso ad alto",
  价格从高到低: "Prezzo da alto a basso",
  选择交货类型: "Seleziona il tipo di consegna",
  送货上门: "Consegna",
  继续付款: "Continua a pagare",
  任何其他信息: "qualunque altra informazione",
  或者: "O",
  您的钱包余额: "Il saldo del tuo portafoglio",
  余额不足: "Equilibrio insufficiente",
  支付: "paga",
  我同意: "Sono d'accordo",
  条款和条件: "Termini e Condizioni",
  退货政策: "politica di ritorno",
  隐私政策: "politica sulla riservatezza",
  概括: "generalizzare",
  项目: "progetto",
  全部的: "Tutto",
  小计: "totale parziale",
  总运费: "costo totale di spedizione",
  有优惠码吗_在这里输入: "C'è un codice sconto? entra qui",
  申请: "Fare domanda a",
  编辑: "modificare",
  删除: "eliminare",
  添加新地址: "Aggiungi un nuovo indirizzo",
  继续交货信息: "Continua le informazioni sulla consegna",
  选择一个地址: "Scegli un indirizzo",
  购买历史: "Cronologia degli acquisti",
  下载: "scaricamento",
  已发送退款请求: "Richiesta di rimborso inviata",
  对比: "Rispetto",
  对话: "dialogo",
  我的钱包: "La mia borsetta",
  工单: "ordine di lavoro",
  管理个人资料: "Gestisci profilo",
  登出: "disconnessione",
  重置对比列表: "Reimposta l'elenco di confronto",
  您的对比列表为空: "La tua lista di confronto è vuota",
  在您的购物车中: "nel tuo carrello",
  在您的愿望清单中: "nella tua lista dei desideri",
  在您的预定列表中: "sulla tua lista di prenotazione",
  下载您的产品: "Scarica il tuo prodotto",
  选项: "Opzioni",
  什么都没找到: "Non abbiamo trovato nulla",
  特色产品: "Prodotti sponsorizzati",
  最畅销: "Best seller",
  前_名: "Primi {0}",
  查看更多: "Vedi altro",
  查看所有类别: "Visualizza tutte le categorie",
  十大品牌: "I dieci migliori marchi",
  查看所有品牌: "Visualizza tutti i marchi",
  登录: "Login",
  手机号码: "numero di telefono",
  密码: "parola d'ordine",
  密码长度为6到16个字符:
    "La lunghezza della password è compresa tra 6 e 16 caratteri",
  验证码: "Codice di verifica",
  登录中: "Login",
  游客登录: "Accesso visitatore",
  注册您的商店: "Registra il tuo negozio",
  现在申请: "Applica ora",
  成为商家: "Diventa un commerciante",
  现在注册: "Iscriviti ora",
  登录成功: "Atterrato con successo",
  通知: "notificare",
  未找到通知: "notifica non trovata",
  评论: "Commento",
  估计运输时间: "Tempo di spedizione stimato",
  天: "cielo",
  所售: "venduto",
  给商家留言: "Lascia un messaggio al commerciante",
  规格: "Specifica",
  库存: "in magazzino",
  总价: "prezzo totale",
  添加到购物车: "Aggiungi al carrello",
  立即购买: "Compralo Subito",
  缺货: "esaurito",
  添加到愿望清单: "Aggiungi alla lista dei desideri",
  加入对比列表: "Aggiungi all'elenco di confronto",
  退款: "Rimborso",
  查看条款: "Visualizza i termini",
  分享: "condividere",
  描述: "descrivere",
  相关产品: "prodotti correlati",
  没有人问过商家: "Nessuno ha chiesto ai commercianti",
  该产品暂无评论: "Non ci sono ancora recensioni per questo prodotto",
  客户评论: "recensioni dei clienti",
  访问商店: "visita il negozio",
  畅销产品: "Bestseller",
  日期: "data",
  订单编号: "numero d'ordine",
  总额: "forfettario",
  状态: "stato",
  愿望清单: "Lista dei desideri",
  还没有添加任何东西: "Non è stato ancora aggiunto nulla",
  注册: "Registrati",
  邀请码: "Codice invito",
  请输入邀请码: "Inserisci il codice di invito",
  用户名: "nome utente",
  请输入用户名: "per favore inserisci il nome utente",
  用户名长度为6_14个字符: "La lunghezza del nome utente è di 6-14 caratteri",
  昵称: "Soprannome",
  请输入手机号码: "Inserisci il numero di telefono",
  手机号码格式错误: "Formato errato del numero di telefono",
  密码长度为6_16个字符:
    "La lunghezza della password è compresa tra 6 e 16 caratteri",
  确认密码: "Conferma password",
  请输入确认密码: "Inserisci la password di conferma",
  提款密码: "Password di prelievo",
  请输入提款密码: "Inserisci la password di prelievo",
  提款密码长度为4_16个字符:
    "La lunghezza della password di prelievo è compresa tra 4 e 16 caratteri",
  请输入验证码: "inserisci il codice di verifica",
  在_s后发送: "Inviato dopo {0}s",
  发送验证码: "Invia il codice di verifica",
  注册即表示您同意我们的条款和条件:
    "Iscrivendoti accetti i nostri termini e condizioni.",
  创建账号: "Creare un account",
  验证码发送成功: "Codice di verifica inviato con successo",
  确认密码不一致: "Confermare che la password non è coerente",
  提款密码必须为数字: "La password di prelievo deve essere numerica",
  注册成功: "Registrazione avvenuta",
  购物车: "carrello della spesa",
  账户: "Account",
  我的账户: "il mio conto",
  已经有一个账户: "Hai già un account",
  新地址: "nuovo indirizzo",
  编辑地址: "Modifica indirizzo",
  保存: "salva",
  是否默认: "È l'impostazione predefinita?",
  具体地址: "Indirizzo specifico",
  请输入具体地址: "Inserisci l'indirizzo specifico",
  地区: "la zona",
  请输入地区: "Inserisci la regione",
  城市: "Città",
  请输入城市: "Per favore inserisci la città",
  省份: "Provincia",
  请输入省份: "Inserisci la provincia",
  邮政编码: "Codice Postale",
  请输入邮政编码: "Inserisci il codice postale",
  电话号码: "numero di telefono",
  请输入电话号码: "Per favore immetti il ​​tuo numero di telefono",
  收货人: "Ricevitore",
  请输入收货人: "Inserisci il destinatario",
  保存成功: "Salvato con successo",
  最畅销的商家: "I commercianti più venduti",
  查看所有的商家: "Visualizza tutte le attività commerciali",
  支持政策: "Politica di sostegno",
  您的电子邮件地址: "Il tuo indirizzo di posta elettronica",
  订阅: "sottoscrizione",
  联系方式: "Informazioni sui contatti",
  地址: "indirizzo",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, Stati Uniti",
  快速链接: "Link veloci",
  商家政策: "Politiche commerciali",
  submit: "invia",
  提款银行卡: "Carta bancaria per il prelievo",
  我的面板: "il mio pannello",
  提示: "suggerimento",
  确定登出吗: "Sei sicuro di voler uscire?",
  确定: "Sicuro",
  取消: "Annulla",
  项目添加到您的购物车: "Aggiungi l'articolo al tuo carrello",
  经常一起购买: "spesso acquistano insieme",
  返回购物: "Ritorno allo shopping",
  进行结算: "procedere al checkout",
  帮助热线: "Assistenza telefonica",
  查看所有通知: "Visualizza tutte le notifiche",
  请输入密码: "Per favore, inserisci la password",
  前往充值: "Vai a ricaricare",
  购物车物品: "Articoli del carrello",
  查看购物车: "controlla il carrello",
  钱包余额: "saldo del portafoglio",
  充值钱包: "Ricarica il portafoglio",
  钱包充值_线下_: "Ricarica portafoglio (offline)",
  申请提款: "Richiedere il ritiro",
  钱包收支明细: "Dettagli sulle entrate e sulle spese del portafoglio",
  批准: "approvare",
  提现历史记录: "Storia dei prelievi",
  类型: "tipo",
  信息: "informazione",
  付款方式: "metodo di pagamento",
  请选择付款方式: "Scegli un metodo di pagamento",
  Bill_Type_RECHARGE_BACK: "Ricarica back-end",
  Bill_Type_RECHARGE_ONLINE: "Ricarica on-line",
  Bill_Type_RECHARGE_REGISTER: "Registrati GRATIS",
  Bill_Type_RECHARGE_JACKPOT: "Bonus ricarica",
  Bill_Type_RECHARGE_PRESENT: "Ricarica i premi",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Trasferimento della commissione",
  Bill_Type_RECHARGE_TG_COMMISSION: "Ricaricare la commissione di promozione",
  Bill_Type_REGISTER_TG_COMMISSION:
    "Commissione per la promozione della registrazione",
  Bill_Type_WITHDRAW: "ritirare",
  Bill_Type_WITHDRAW_REJECT: "Ritiro respinto",
  Bill_Type_DEDUCT_HANDLE: "Detrazione manuale",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Correzione della ricarica",
  Bill_Type_MINING_PROFIT: "Reddito minerario",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Commissione per la promozione del reddito minerario",
  Bill_Type_VIP_UPGRADE: "Aggiorna VIP",
  Bill_Type_FINANCE_BUY: "Acquistare prodotti finanziari",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Ritorno dell'equilibrio finanziario",
  Bill_Type_FINANCE_FEE: "Commissioni di gestione finanziaria",
  Bill_Type_FINANCE_PROFIT: "Proventi della gestione finanziaria",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Commissione per l'acquisto di prodotti finanziari",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Commissione sui ricavi dei prodotti finanziari",
  Bill_Type_WHEEL_DRAW: "Lotteria della grande ruota",
  Bill_Type_BUY: "acquistare beni",
  Bill_Type_PAY_SHOP: "Pagare la spedizione",
  Bill_Type_BUY_COMMISSION: "Commissione sugli articoli acquistati",
  Bill_Type_DEPOSIT: "Pagare il deposito",
  Bill_Type_STORE_BUY: "acquistare beni",
  Bill_Type_STORE_BUY_REFUND: "Acquista il rimborso del prodotto",
  Bill_Type: "Tipo di modifica dell'account",
  Before_Money: "importo precedente",
  Deal_Money: "Importo della modifica del conto",
  After_Money: "Importo dopo",
  Bill_Time: "Orario di modifica dell'account",
  No_More_Data: "niente più dati",
  Apply_Money: "Importo della domanda",
  Apply_Time: "tempo di applicazione",
  Withdraw_Info: "Spese di gestione: {fee}, arrivo: {money}",
  提款订单状态_CHECKING: "Revisione in atto",
  提款订单状态_TRANSFERRING: "Trasferimento",
  提款订单状态_PASS: "confermato",
  提款订单状态_REJECT: "Licenziato",
  暂无可用充值方式: "Nessun metodo di ricarica ancora disponibile",
  钱包收款码: "Codice di pagamento del portafoglio",
  钱包地址: "indirizzo del portafoglio",
  金额限制: "Limite di importo",
  复制: "copia",
  付款凭证: "buono di pagamento",
  收款银行: "Banca di destinazione",
  收款人: "Beneficiario",
  收款账号: "Numero del conto di pagamento",
  付款银行: "banca di pagamento",
  付款人: "Pagatore",
  付款账号: "Conto di Pagamento",
  请输入付款银行: "Inserisci la banca di pagamento",
  请输入付款人: "Inserisci il pagatore",
  请输入付款账号: "Inserisci il numero del conto di pagamento",
  请上传付款凭证: "Si prega di caricare il voucher di pagamento",
  充值金额: "Importo della ricarica",
  请输入充值金额: "Inserisci l'importo della ricarica",
  submitting: "invio...",
  Confirm: "invia",
  Commit_Success: "Inserito con successo",
  balanceType_BALANCE: "bilancia",
  balanceType_COMMISSION: "commissione",
  Balance: "Saldo del conto",
  Wash_Money: "aggiungi mosaico",
  请选择银行账户: "Seleziona un conto bancario",
  卡号类型: "Tipo di numero della carta",
  提现金额: "Importo del prelievo",
  提款金额: "Importo del prelievo",
  不能为空: "Non può essere vuoto",
  金额不正确: "L'importo non è corretto",
  please_input_withdraw_password: "Inserisci la password di prelievo",
  withdraw_password_format_error:
    "La password di prelievo deve contenere da 4 a 16 caratteri",
  Fee: "commissione di gestione",
  实际到账: "Arrivo effettivo",
  交易币种: "Valuta di transazione",
  原始密码: "password originale",
  confirm_password_error: "La password inserita due volte non è corretta",
  save_success: "Salvato con successo",
  please_input: "prego entra",
  old_password: "vecchia password",
  new_password: "nuova password",
  please_input_confirm_password:
    "Si prega di confermare nuovamente la password",
  没有找到符合条件的商品: "Nessun prodotto corrispondente trovato",
  Search: "ricerca",
  全部: "Tutto",
  EnumGoodsOrderState_USER_PAY: "In attesa di consegna",
  EnumGoodsOrderState_SHOP_PAY: "Consegnare",
  EnumGoodsOrderState_SUCCESS: "Fine",
  EnumGoodsOrderState_CANCEL: "Annullato",
  EnumGoodsOrderState_REFUND_SUCCESS: "rimborsato",
  订单号: "numero d'ordine",
  用户名称: "nome utente",
  收益: "reddito",
  支付时间: "Tempo di pagamento",
  配送时间: "Tempi di consegna",
  完成时间: "Tempo completo",
  发货: "Nave",
  全选: "seleziona tutto",
  物品已添加到愿望清单: "Articolo aggiunto alla lista dei desideri",
  物品已添加到比较列表: "Articolo aggiunto all'elenco di confronto",
  购买成功提示: "Congratulazioni, il tuo acquisto è andato a buon fine",
  订单列表: "Lista degli ordini",
  商品名: "Nome del prodotto",
  图片: "immagine",
  没有品牌: "senza marchio",
  基本信息: "Informazioni di base",
  Account_Name: "Nome di apertura del conto",
  Bank_Account: "Conto bancario",
  Bank_Phone: "Prenota il numero di cellulare",
  IFSC: "Conto IFSC",
  UPI: "Conto UPI",
  PIX: "Conto PIX",
  CPF: "Conto CPF",
  GCASH: "Conto GCASH",
  POWWI: "Conto POWWI",
  身份证号: "Numero di identificazione",
  Edit: "Rivedere",
  Delete: "eliminare",
  Add: "Nuovo",
  Forget_Withdraw_Password: "Password di prelievo dimenticata",
  Bank_Card_Info: "Informazioni sulla carta bancaria",
  收款人地址: "Indirizzo del beneficiario",
  SWIFT: "VELOCE",
  Bank_Branch: "Nome della filiale",
  分行代码: "codice della filiale",
  银行地址: "indirizzo bancario",
  Email: "E-mail",
  银行卡长度必须超过:
    "La lunghezza della carta bancaria deve superare {length}",
  银行卡格式不正确: "Il formato della carta bancaria non è corretto",
  Do_you_confirm_delete: "Confermare la cancellazione?",
  Please_Login_First: "per favore fai prima il log in",
  Bank_Name: "nome della banca",
  Please_add_bank_first:
    "Non hai ancora vincolato la tua carta bancaria, aggiungila prima",
  withdrawType: "Tipo di ritiro",
  withdraw_money_limit:
    "L'importo del prelievo deve essere maggiore di 0 e minore o uguale a {saldo}",
  withdraw_times_limit:
    "Hai prelevato {todayWithdrawNum} volte oggi e ti verrà addebitata una commissione di gestione del {withdrawFee}% dopo {limitTimes} volte. Sei sicuro di ritirarti?",
  Copy_Success: "Copiato con successo",
  商店首页: "Home page del negozio",
  所有产品: "Tutti i prodotti",
  新到货产品: "Prodotti appena arrivati",
  所有商家: "Tutti i commercianti",
  请上传: "Per favore carica",
  请输入: "prego entra",
  忘记密码: "dimenticare la password",
  记得我: "Ricordati di me",
  共_件: "Totale {0} articoli",
  取消订单: "Annulla Ordine",
  申请退款: "Richiedere un rimborso",
  未知商家: "Commerciante sconosciuto",
  到账: "Ricevuta",
  提款订单状态: "Stato dell'ordine di ritiro",
  前_名类别: "Principali {0} categorie",
  取消订单原因_不想要了: "Non lo voglio più",
  取消订单原因_商品错选_多选:
    "Selezione del prodotto errata/selezioni multiple",
  取消订单原因_商品无货: "Prodotto esaurito",
  取消订单原因_地址信息填写错误:
    "Informazioni sull'indirizzo inserite in modo errato",
  取消订单原因_商品降价: "Riduzione del prezzo del prodotto",
  取消订单原因_价格高于其他平台:
    "Il prezzo è più alto rispetto ad altre piattaforme",
  取消订单原因_没用_少用_错用优惠:
    "Nessun utilizzo/minore utilizzo/abuso degli sconti",
  退款原因_拍错_多拍_不喜欢: "Tiro sbagliato/tiro extra/non mi piace",
  退款原因_商品成分描述不符:
    "La descrizione degli ingredienti del prodotto non corrisponde",
  退款原因_与商家协商一致退款: "Rimborso come concordato con il commerciante",
  退款原因_生产日期_保质期与商品描述不符:
    "La data di produzione/durata di conservazione non corrisponde alla descrizione del prodotto",
  退款原因_图片_产地_批号_规格等描述不符:
    "Immagini/provenienza/numero di lotto/specifiche e altre descrizioni non corrispondono",
  退款原因_质量问题: "Problemi di qualità",
  退款原因_商品变质_发霉_有异物:
    "Il prodotto è rovinato/ammuffito/presenta corpi estranei",
  退款原因_少件_含缺少配件_: "Pochi pezzi (compresi accessori mancanti)",
  退款原因_收到商品时有破损_污渍_变形:
    "L'articolo era danneggiato/macchiato/deformato al momento della ricezione.",
  退款原因_假冒品牌: "Marchi contraffatti",
  退款原因_发票问题: "Problemi con le fatture",
  退款原因_商家发错货: "Il commerciante ha inviato la merce sbagliata",
  退款原因_预约不到_商家不给退换:
    "Impossibile fissare un appuntamento/il commerciante non effettua resi o cambi",
  退款失败: "Rimborso non riuscito",
  退款处理中: "Rimborso in corso",
  默认: "predefinito",
  产品查询: "Ricerca prodotto",
  商店LOGO: "Memorizzare il LOGO",
  推广码: "Codice promozionale",
  查看所有: "mostra tutto",
  确认收货成功: "Confermare la ricezione della merce con successo",
  物流公司: "Azienda logistica",
  物流单号: "numero di spedizione",
  发货时间: "Tempi di spedizione",
  请先选择商品规格: "Selezionare prima le specifiche del prodotto",
  个人信息: "informazione personale",
  您的用户名: "il tuo nome utente",
  你的名字: "il tuo nome",
  登录名: "nome utente",
  你的邮件: "la tua email",
  你的密码: "la tua password",
  重复输入密码: "Ripeti la password",
  店铺名称: "Nome del negozio",
  证书类型: "Tipo di certificato",
  身份证: "carta d'identità",
  护照: "passaporto",
  驾驶执照: "patente di guida",
  社会保障卡: "Tessera di previdenza sociale",
  证书正面: "Certificato anteriore",
  证书反面: "Retro del certificato",
  确认收货: "confermare la ricezione della merce",
  请选择取消订单的原因必选:
    "Seleziona il motivo dell'annullamento dell'ordine (richiesto):",
  请选择申请退款的原因必选:
    "Seleziona il motivo della richiesta di rimborso (richiesto):",
  留言: "Messaggio",
  请输入留言: "Per favore inserisci un messaggio",
  没有帐户: "Nessun conto",
  钱包充值: "Ricarica portafoglio",
  输入您的文字: "Inserisci il tuo testo",
  商家登录: "Accesso commerciante",
  有关此产品的任何查询: "Qualsiasi domanda su questo prodotto",
  产品名称: "nome del prodotto",
  你的问题: "il tuo problema",
  白银店铺: "negozio d'argento",
  铂金店铺: "negozio di platino",
  钻石店铺: "negozio di diamanti",
  照片: "foto",
  已退货: "Restituito",
  邮寄状态: "Stato della spedizione",
  订单摘要: "Riepilogo dell'ordine",
  收件地址: "Indirizzo del destinatario",
  订购日期: "Data dell'ordine",
  订单状态: "Lo stato dell'ordine",
  总订单金额: "Importo totale dell'ordine",
  邮寄方式: "Metodo di spedizione",
  附加信息: "Informazioni aggiuntive",
  订单详细信息: "Dettagli dell'ordine",
  交货类型: "Tipo di consegna",
  进行评论: "Fai un commento",
  已评论: "Commentato",
  订单金额: "Ammontare dell'ordine",
  优惠券: "buono",
  统一运费: "Spese di spedizione forfettarie",
  送货地址: "Indirizzo di spedizione",
  评分: "punto",
  你的意见: "la tua opinione",
  匿名: "anonimo",
  现金: "contanti",
  详情: "Dettagli",
  收货地址: "Indirizzo di spedizione",
  暂时没有对话: "Nessuna conversazione ancora",
  你: "Voi",
  输入您的回复: "Inserisci la tua risposta",
  删除成功: "eliminato con successo",
  品牌: "marca",
  已缴纳的保证金: "Deposito cauzionale pagato",
  黄金店铺: "negozio d'oro",
  没有更多数据: "niente più dati",
  站内信: "Messaggio del sito",
  系统通知: "notifica del sistema",
  邮箱: "Posta",
  手机号: "Numero di telefono",
  你的手机号: "il tuo numero di telefono",
  营业执照: "licenza d'affari",
  你的邮箱: "la tua casella di posta",
  搜索结果: "risultati di ricerca",
  系统公告: "notifica del sistema",
  客服: "assistenza clienti",
  消息已撤回: "Il messaggio è stato ritirato",
  物流详情: "Dettagli logistici",
  充值: "Riempire",
  提现: "ritirare",
  信用分: "punteggio di credito",
  余额: "bilancia",
  佣金: "commissione",
  继续购物: "continua a fare acquisti",
  订单结算: "Regolamento dell'ordine",
  加入对比: "Aggiungi al confronto",
  佣金余额: "Saldo della Commissione",
  刷新: "ricaricare",
  刷新成功: "Aggiornamento riuscito",
  官网: "Sito ufficiale",
  税号: "Codice fiscale",
  订单: "Ordine",
  合计: "totale",
  系统安全: "Sicurezza del sistema",
  Recharge_Money_Limit:
    "L'importo della ricarica deve essere compreso tra {min} e {max}",
  限时优惠: "Offerta a tempo limitato",
  高价回收: "Riciclaggio ad alto prezzo",
  姓名: "Nome",
  商品订单号: "Numero dell'ordine del prodotto",
  商品在线回收: "Riciclaggio online dei prodotti",
  提交: "invia",
  回收记录: "Documenti di riciclaggio",
  回收状态: "Stato di riciclaggio",
  回收价格: "prezzo del riciclaggio",
  纳税码: "codice fiscale",
  买家登录: "Login",
  买家注册: "registro",
  language: "意大利语",
  助力提示:
    "Aiutare i commercianti può aumentare l'esposizione della piattaforma ai loro negozi e maggiore è il numero cumulativo di giorni, maggiore è l'esposizione.",
  已累计助力: "Assistito cumulativamente",
  今日已助力: "Oggi ha aiutato",
  立即助力: "Aiutare immediatamente",
  商家助力: "Aiuto mercantile",
  证件号码: "Numero ID",
  证书号码: "Numero certificato"
};
